import React, { useState } from 'react';
import IntakeForm from './components/IntakeForm/IntakeForm';
import SubmittedView from './components/ProcessingView/SubmittedView';
import CompleteView from './components/ProcessingView/CompleteView';
import { submitKernel, triggerIntakeAgent, pollKernelStatus } from './utils/api';
import './styles/variables.css';
import './styles/global.css';
import './App.css';

function App() {
  const [view, setView] = useState('form'); // 'form', 'processing', 'complete'
  const [kernelId, setKernelId] = useState(null);
  const [kernel, setKernel] = useState(null);

  const handleFormSubmit = async (formData) => {
    try {
      // Submit kernel
      const submitResponse = await submitKernel(formData);
      const newKernelId = submitResponse.kernel_id;
      setKernelId(newKernelId);

      // Switch to processing view
      setView('processing');

      // Trigger intake agent
      await triggerIntakeAgent(newKernelId);

      // Poll for completion
      const completedKernel = await pollKernelStatus(newKernelId, (updatedKernel) => {
        setKernel(updatedKernel);
      });

      setKernel(completedKernel);
      setView('complete');
    } catch (error) {
      console.error('Error during submission:', error);
      alert('Error: ' + error.message);
      setView('form');
    }
  };

  const handleReset = () => {
    setView('form');
    setKernelId(null);
    setKernel(null);
  };

  return (
    <div className="app">
      <header className="app__header">
        <div className="app__header-content">
          <img src="/logo.png" alt="CONDITIONAL" className="app__logo" />
          <div className="app__header-text">
            <h1 className="app__title">CONDITIONAL</h1>
            <p className="app__subtitle">Private Data Intake</p>
          </div>
        </div>
      </header>

      <main className="app__main">
        {view === 'form' && (
          <IntakeForm onSubmitComplete={handleFormSubmit} />
        )}

        {view === 'processing' && (
          <SubmittedView
            kernelId={kernelId}
            status={kernel?.status || 'submitted'}
            kernel={kernel}
          />
        )}

        {view === 'complete' && (
          <CompleteView kernel={kernel} onReset={handleReset} />
        )}
      </main>

      <footer className="app__footer">
        <p className="app__footer-text">
          Markets for people who reason
        </p>
      </footer>
    </div>
  );
}

export default App;
